import React, { Component } from "react";
import Axios from "axios";
import { Link } from "react-router-dom";
import "../../css/style.css";

import $ from "jquery";
import Constant from "../Constant";
import { getAccessToken } from "../../hooks/AccessToken";
import { getCategory } from "../../service/CommonServices";
import { toast } from "react-toastify";

class AddUpdate extends Component {
  state = {
    name: "",
    image: null,
    mobileImage: null,
    mobileImageUrl: "",
    about: "",
    startDate: "",
    startTime: "",
    closureDate: "",
    closureTime: "",
    resultDate: "",
    resultTime: "",
    totalNumberOfWinners: 1,
    languageBasedModel: true,
    storyPrice: 0,
    poemPrice: 0,
    type: "story",
    idCard: false,
    refId: false,
    cityName: false,
    collegeName: false,
    collegeAddress: false,
    mobileNumber: false,
    durationRequired: true,
    wordLimit: "", // empty = no limit (null)
    noReview: false,
    noVoting: false,
    targetRequired: true,
    defaultTarget: "everyone",
    categoryControl: "user_selects",
    defaultCategory: "",
    categoryList: [],
    languages: [],
    winnersPerLanguage: 1,
    availableLanguages: [],
    getData: {},
    selectArea: 0,
    ERROR: true,
    // Validation states
    startDateError: "",
    startTimeError: "",
    closureDateError: "",
    closureTimeError: "",
    resultDateError: "",
    resultTimeError: "",
    // Upload states
    mobileImageUploading: false,
    mobileImageUploadError: "",
  };

  // Validation methods
  validateClosureDateTime = () => {
    const { startDate, startTime, closureDate, closureTime } = this.state;

    // Clear previous errors first
    this.setState({
      startDateError: "",
      startTimeError: "",
      closureDateError: "",
      closureTimeError: "",
    });

    // Only validate if we have both start and closure date/time
    if (startDate && startTime && closureDate && closureTime) {
      const startDateTime = new Date(`${startDate}T${startTime}`);
      const closureDateTime = new Date(`${closureDate}T${closureTime}`);

      if (closureDateTime <= startDateTime) {
        this.setState({
          startDateError: "Closure date/time must be after start date/time",
          startTimeError: "Closure date/time must be after start date/time",
          closureDateError: "Closure date/time must be after start date/time",
          closureTimeError: "Closure date/time must be after start date/time",
        });
        return false;
      }
    }
    return true;
  };

  validateResultDateTime = () => {
    const { closureDate, closureTime, resultDate, resultTime } = this.state;

    // Clear previous errors first
    this.setState({
      closureDateError: "",
      closureTimeError: "",
      resultDateError: "",
      resultTimeError: "",
    });

    // Only validate if we have both closure and result date/time
    if (closureDate && closureTime && resultDate && resultTime) {
      const closureDateTime = new Date(`${closureDate}T${closureTime}`);
      const resultDateTime = new Date(`${resultDate}T${resultTime}`);

      if (resultDateTime <= closureDateTime) {
        this.setState({
          closureDateError: "Result date/time must be after closure date/time",
          closureTimeError: "Result date/time must be after closure date/time",
          resultDateError: "Result date/time must be after closure date/time",
          resultTimeError: "Result date/time must be after closure date/time",
        });
        return false;
      }
    }
    return true;
  };

  // Enhanced handleChange with validation
  handleChange = (e) => {
    const { id, value, type, checked } = e.target;

    if (type === "checkbox" && id.startsWith("language-")) {
      const languageName = id.replace("language-", "");
      this.setState((prevState) => {
        const languages = checked
          ? [...prevState.languages, languageName]
          : prevState.languages.filter((name) => name !== languageName);
        // Calculate total winners
        const totalNumberOfWinners =
          languages.length * prevState.winnersPerLanguage;
        return {
          languages,
          totalNumberOfWinners,
        };
      });
    } else if (id === "winnersPerLanguage") {
      const winnersPerLanguage = parseInt(value);
      this.setState((prevState) => ({
        winnersPerLanguage,
        totalNumberOfWinners: prevState.languages.length * winnersPerLanguage,
      }));
    } else if (id === "totalNumberOfWinners") {
      // Do nothing, field is now always read-only
    } else {
      // Handle other fields
      if (
        id === "idCard" ||
        id === "refId" ||
        id === "cityName" ||
        id === "collegeName" ||
        id === "collegeAddress" ||
        id === "mobileNumber" ||
        id === "durationRequired" ||
        id === "noReview" ||
        id === "noVoting" ||
        id === "targetRequired"
      ) {
        this.setState({
          [id]: value === "true",
        });
      } else {
        this.setState(
          {
            [id]: value,
          },
          () => {
            // Run validation after state update
            if (
              id === "startDate" ||
              id === "startTime" ||
              id === "closureDate" ||
              id === "closureTime"
            ) {
              this.validateClosureDateTime();
            }
            if (
              id === "closureDate" ||
              id === "closureTime" ||
              id === "resultDate" ||
              id === "resultTime"
            ) {
              this.validateResultDateTime();
            }
          }
        );
      }
    }
  };

  handleImageChange = (e) => {
    this.setState({
      [e.target.id]: e.target.files[0],
    });
  };

  handleMobileImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) {
      this.setState({
        mobileImage: null,
        mobileImageUrl: "",
        mobileImageUploadError: "",
      });
      return;
    }

    // Validate file type
    const extension = file.name.split(".").pop().toLowerCase();
    if (extension !== "jpg" && extension !== "png" && extension !== "jpeg") {
      this.setState({
        mobileImageUploadError:
          "Only jpg, jpeg and png file types are allowed!",
      });
      return;
    }

    this.setState({
      mobileImage: file,
      mobileImageUploading: true,
      mobileImageUploadError: "",
    });

    try {
      // Upload to S3
      const uploadUrl = await this.uploadMobileImageToS3(file);
      this.setState({
        mobileImageUrl: uploadUrl,
        mobileImageUploading: false,
      });
    } catch (error) {
      console.error("Error uploading mobile image:", error);
      this.setState({
        mobileImageUploading: false,
        mobileImageUploadError:
          "Failed to upload mobile image. Please try again.",
      });
    }
  };

  uploadMobileImageToS3 = async (file) => {
    const token = getAccessToken();
    const formData = new FormData();
    formData.append("mobileImage", file);

    const response = await Axios.post(
      Constant.apiBasePath + "contest/upload-mobile-image",
      formData,
      {
        headers: {
          token: token,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response.data && response.data.url) {
      return response.data.url;
    } else {
      throw new Error("No URL returned from upload");
    }
  };

  handleSubmit = async (event) => {
    try {
      event.preventDefault();

      // Run validation before submission
      const closureValid = this.validateClosureDateTime();
      const resultValid = this.validateResultDateTime();

      if (!closureValid || !resultValid) {
        toast.error("Please fix the date/time validation errors before submitting");
        return false;
      }

      let token = getAccessToken();
      let id = this.props.match.params.id;
      const form_data = new FormData();

      if (id === undefined) {
        console.log("clicked add button");

        if (this.state.image === null) {
          toast.error("File is required");
          return false;
        }

        let fileName = this.state.image.name;
        let extension = fileName.split(".").pop();

        if (extension !== "jpg" && extension !== "png") {
          toast.error("Only jpg and png file type are allowed!");
          return false;
        }

        // Updated to remove languageBasedModel and prize/tag fields
        Object.entries(this.state).forEach(([key, value]) => {
          if (
            key === "idCard" ||
            key === "refId" ||
            key === "cityName" ||
            key === "collegeName" ||
            key === "collegeAddress" ||
            key === "languageBasedModel" ||
            key === "mobileNumber" ||
            key === "durationRequired" ||
            key === "noReview" ||
            key === "noVoting" ||
            key === "targetRequired"
          ) {
            form_data.append(key, Boolean(value));
          } else if (key === "languages") {
            // Send each language ID as a separate form field
            const languages = Array.isArray(value) ? value : [];
            languages.forEach((langId, index) => {
              form_data.append(`languages[${index}]`, langId);
            });
          } else if (
            key !== "getData" &&
            key !== "ERROR" &&
            key !== "selectArea" &&
            key !== "availableLanguages" &&
            key !== "categoryList" &&      // UI-only: not a backend field
            key !== "categoryControl" &&   // handled explicitly below
            key !== "defaultCategory" &&   // handled explicitly below
            key !== "defaultTarget" &&     // handled explicitly below
            key !== "mobileImage" &&
            key !== "mobileImageUrl" &&    // aliased to mobileImage below
            key !== "mobileImageUploading" &&
            key !== "mobileImageUploadError" &&
            key !== "startDateError" &&
            key !== "startTimeError" &&
            key !== "closureDateError" &&
            key !== "closureTimeError" &&
            key !== "resultDateError" &&
            key !== "resultTimeError" &&
            key !== "wordLimit" &&         // handled separately below
            value !== null
          ) {
            if (key === "image") {
              form_data.append(key, value, value.name);
            } else {
              form_data.append(key, value);
            }
          }
        });

        // Handle mobileImage explicitly
        if (this.state.mobileImageUrl) {
          form_data.append("mobileImage", this.state.mobileImageUrl);
        }

        // Always append languages field, even if empty
        if (!form_data.has("languages[0]")) {
          form_data.append("languages[0]", "");
        }
        // wordLimit: always append current state value; empty string will be processed by backend as null
        form_data.append("wordLimit", this.state.wordLimit !== null && this.state.wordLimit !== undefined ? this.state.wordLimit : "");
        // categoryControl and defaultCategory: always send explicit values
        form_data.append("categoryControl", this.state.categoryControl || "user_selects");
        form_data.append("defaultCategory", this.state.defaultCategory !== null && this.state.defaultCategory !== undefined ? this.state.defaultCategory : "");
        form_data.append("defaultTarget", this.state.defaultTarget || "everyone");

      } else {
        let getData = this.state.getData;
        const appendFormData = (key, stateValue, defaultValue) => {
          if (
            key === "idCard" ||
            key === "refId" ||
            key === "cityName" ||
            key === "collegeName" ||
            key === "collegeAddress" ||
            key === "languageBasedModel" ||
            key === "mobileNumber" ||
            key === "durationRequired" ||
            key === "noReview" ||
            key === "noVoting" ||
            key === "targetRequired"
          ) {
            const value =
              stateValue !== undefined
                ? Boolean(stateValue)
                : Boolean(defaultValue);
            form_data.append(key, value);
          } else if (key === "languages") {
            // Send each language ID as a separate form field
            const languages = Array.isArray(stateValue)
              ? stateValue
              : Array.isArray(defaultValue)
                ? defaultValue
                : [];
            languages.forEach((langId, index) => {
              form_data.append(`languages[${index}]`, langId);
            });
          } else if (stateValue) {
            if (key === "image" && stateValue.name) {
              form_data.append(key, stateValue, stateValue.name);
            } else {
              form_data.append(key, stateValue);
            }
          } else if (defaultValue !== undefined) {
            form_data.append(key, defaultValue);
          }
        };
        // All form fields including new ones
        appendFormData("name", this.state.name, getData.name);
        appendFormData("image", this.state.image, getData.image);
        appendFormData(
          "mobileImage",
          this.state.mobileImageUrl,
          getData.mobileImage
        );
        appendFormData("about", this.state.about, getData.about);
        appendFormData("startDate", this.state.startDate, getData.startDate);
        appendFormData("startTime", this.state.startTime, getData.startTime);
        appendFormData(
          "closureDate",
          this.state.closureDate,
          getData.closureDate
        );
        appendFormData(
          "closureTime",
          this.state.closureTime,
          getData.closureTime
        );
        appendFormData("resultDate", this.state.resultDate, getData.resultDate);
        appendFormData("resultTime", this.state.resultTime, getData.resultTime);
        appendFormData("type", this.state.type, getData.type);
        appendFormData(
          "totalNumberOfWinners",
          this.state.totalNumberOfWinners,
          getData.totalNumberOfWinners
        );
        appendFormData("idCard", this.state.idCard, getData.idCard);
        appendFormData("refId", this.state.refId, getData.refId);
        appendFormData("cityName", this.state.cityName, getData.cityName);
        appendFormData(
          "collegeName",
          this.state.collegeName,
          getData.collegeName
        );
        appendFormData(
          "collegeAddress",
          this.state.collegeAddress,
          getData.collegeAddress
        );
        appendFormData("languageBasedModel", true, true);
        appendFormData("languages", this.state.languages, getData.languages);
        appendFormData(
          "winnersPerLanguage",
          this.state.winnersPerLanguage,
          getData.winnersPerLanguage
        );
        appendFormData("storyPrice", this.state.storyPrice, getData.storyPrice);
        appendFormData("poemPrice", this.state.poemPrice, getData.poemPrice);
        appendFormData(
          "mobileNumber",
          this.state.mobileNumber,
          getData.mobileNumber
        );
        appendFormData(
          "durationRequired",
          this.state.durationRequired,
          getData.durationRequired
        );
        // wordLimit: always append current state value; empty string will be processed by backend as null
        form_data.append("wordLimit", this.state.wordLimit !== null && this.state.wordLimit !== undefined ? this.state.wordLimit : "");
        appendFormData("noReview", this.state.noReview, getData.noReview);
        appendFormData("noVoting", this.state.noVoting, getData.noVoting);
        appendFormData("targetRequired", this.state.targetRequired, getData.targetRequired);
        appendFormData("categoryControl", this.state.categoryControl, getData.categoryControl);
        form_data.append("defaultCategory", this.state.defaultCategory !== null && this.state.defaultCategory !== undefined ? this.state.defaultCategory : "");
        form_data.append("defaultTarget", this.state.defaultTarget || "everyone");
      }
      console.log("after everything");

      const url =
        id === undefined
          ? Constant.apiBasePath + "contest/create"
          : Constant.apiBasePath + "contest/edit/" + id;

      const method = id === undefined ? Axios.post : Axios.patch;
      console.log(method);

      method(url, form_data, {
        headers: { token: token },
      }).then((response) => {
        const getResults = response.data.message;

        if (response.data.status === Constant.statusSuccess) {
          toast.success(getResults);
          setTimeout(function () {
            window.location.href = "/contest-management";
          }, 3000);
        } else {
          toast.error(getResults);
          return false;
        }
      });
    } catch (err) {
      console.log(err);
    }
  };

  getgetData(id) {
    let token = getAccessToken();
    let req = {
      method: "GET",
      url: Constant.apiBasePath + "contest/getDataById/" + id,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        token: token,
      },
      json: true,
    };
    Axios(req)
      .then((response) => {
        const { data } = response;
        if (data.status === Constant.statusSuccess) {
          const contestData = data.data[0];
          this.setState(
            {
              getData: contestData,
              name: contestData.name || "",
              about: contestData.about || "",
              startDate: contestData.startDate || "",
              startTime: contestData.startTime || "",
              closureDate: contestData.closureDate || "",
              closureTime: contestData.closureTime || "",
              resultDate: contestData.resultDate || "",
              resultTime: contestData.resultTime || "",
              idCard: Boolean(contestData.idCard),
              refId: Boolean(contestData.refId),
              cityName: Boolean(contestData.cityName),
              collegeName: Boolean(contestData.collegeName),
              collegeAddress: Boolean(contestData.collegeAddress),
              type: contestData.type || "story",
              languages: contestData.languages || [],
              winnersPerLanguage: contestData.winnersPerLanguage || 1,
              totalNumberOfWinners: contestData.totalNumberOfWinners || 1,
              storyPrice:
                contestData.storyPrice !== undefined
                  ? contestData.storyPrice
                  : 0,
              poemPrice:
                contestData.poemPrice !== undefined
                  ? contestData.poemPrice
                  : 0,
              mobileNumber: Boolean(contestData.mobileNumber),
              durationRequired: Boolean(contestData.durationRequired),
              wordLimit: contestData.wordLimit != null ? contestData.wordLimit : "",
              noReview: Boolean(contestData.noReview),
              noVoting: Boolean(contestData.noVoting),
              targetRequired: contestData.targetRequired !== undefined ? Boolean(contestData.targetRequired) : true,
              defaultTarget: contestData.defaultTarget || "everyone",
              categoryControl: contestData.categoryControl || "user_selects",
              defaultCategory: contestData.defaultCategory || "",
              mobileImageUrl: contestData.mobileImage || "",
              ERROR: false,
            },
            () => {
              // Run validation after state is set
              this.validateClosureDateTime();
              this.validateResultDateTime();
            }
          );
        } else {
          this.setState({ getData: "", ERROR: false });
        }
      })
      .catch((error) => "Something Error");
  }

  fetchLanguages = async () => {
    try {
      const token = getAccessToken();
      const response = await Axios.get(
        Constant.apiBasePath + "language/get-all",
        {
          headers: { token: token },
        }
      );
      console.log("Languages API Response:", response.data);
      // Check if response.data is an array directly
      if (Array.isArray(response.data)) {
        this.setState({ availableLanguages: response.data });
      } else if (response.data.data && Array.isArray(response.data.data)) {
        this.setState({ availableLanguages: response.data.data });
      } else {
        console.error("Unexpected API response format:", response.data);
      }
    } catch (error) {
      console.error("Error fetching languages:", error);
    }
  };

  componentDidMount() {
    let id = this.props.match.params.id;
    if (id !== undefined) {
      this.getgetData(id);
    } else {
      // For new contests, run validation after component mounts
      setTimeout(() => {
        this.validateClosureDateTime();
        this.validateResultDateTime();
      }, 100);
    }
    this.fetchLanguages();
    getCategory().then(data => {
      this.setState({ categoryList: data });
    });
  }

  render() {
    const { getData } = this.state;
    let image = "";
    let totalNumberOfWinners = "";

    let btnVal = "Add";
    let heading = "Add Contest";

    if (getData.name !== undefined) {
      image = getData.image === undefined ? "" : getData.image;
      totalNumberOfWinners = getData.totalNumberOfWinners;
      btnVal = "Update";
      heading = "Update Contest";
    }

    return (
      <div className="content-page contest-add-update-page">
        <div className="content page-content-spaced">
          <div className="event-management-header">
            <div className="header-content">
              <div className="header-title">
                <h4 className="page-title-heading">{heading}</h4>
                <p className="header-subtitle">
                  Configure timeline, entry fields, languages, and winner rules.
                </p>
              </div>
              <div className="header-actions">
                <div className="page-title-right">
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item">
                      <Link to="/contest-management">Contest Management</Link>
                    </li>
                    <li className="breadcrumb-item active">{heading}</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <div className="event-management-body">
          <div className="row">
            <div className="col-12">
              <div className="card contest-form-card">
                <div className="card-body contest-form-card-body">
                  <form onSubmit={this.handleSubmit} className="contest-form-grid">
                    <div className="row">
                      <div className="col-md-12 contest-form-column">
                        <div className="form-group mb-3">
                          <label htmlFor="name" className="update">
                            Name *
                          </label>
                          <input
                            type="text"
                            id="name"
                            className="form-control"
                            value={this.state.name}
                            onChange={this.handleChange}
                            required
                          />
                        </div>
                        <div className="form-group mb-3">
                          <label htmlFor="image" className="update">
                            Image *
                          </label>
                          <input
                            type="file"
                            id="image"
                            className="form-control"
                            onChange={this.handleImageChange}
                            accept=".jpg,.jpeg,.png"
                          />
                          {this.state.image && (
                            <div className="mt-2">
                              <small className="text-info d-block">
                                Selected image: {this.state.image.name}
                              </small>
                            </div>
                          )}
                          {image && (
                            <div className="mt-2">
                              <small className="text-success d-block">
                                Current image:
                              </small>
                              <img
                                src={image}
                                alt="Current image"
                                style={{
                                  maxWidth: "200px",
                                  maxHeight: "150px",
                                  marginTop: "5px",
                                  border: "1px solid #ddd",
                                  borderRadius: "4px",
                                }}
                              />
                            </div>
                          )}
                        </div>
                        <div className="form-group mb-3">
                          <label htmlFor="mobileImage" className="update">
                            Mobile Image (Optional)
                          </label>
                          <input
                            type="file"
                            id="mobileImage"
                            className="form-control"
                            onChange={this.handleMobileImageChange}
                            accept=".jpg,.jpeg,.png"
                          />
                          {this.state.mobileImageUploading && (
                            <small className="text-info d-block mt-1">
                              Uploading mobile image...
                            </small>
                          )}
                          {this.state.mobileImageUploadError && (
                            <small className="text-danger d-block mt-1">
                              {this.state.mobileImageUploadError}
                            </small>
                          )}
                          {this.state.mobileImageUrl && (
                            <div className="mt-2">
                              <small className="text-success d-block">
                                {this.state.mobileImage
                                  ? "Mobile image uploaded successfully!"
                                  : "Current mobile image:"}
                              </small>
                              <img
                                src={this.state.mobileImageUrl}
                                alt="Mobile preview"
                                style={{
                                  maxWidth: "200px",
                                  maxHeight: "150px",
                                  marginTop: "5px",
                                  border: "1px solid #ddd",
                                  borderRadius: "4px",
                                }}
                              />
                            </div>
                          )}
                        </div>
                        <div className="form-group mb-3">
                          <label htmlFor="about" className="update">
                            About *
                          </label>
                          <textarea
                            id="about"
                            className="form-control"
                            value={this.state.about}
                            onChange={this.handleChange}
                            required
                          ></textarea>
                        </div>
                        <div className="form-group mb-3">
                          <label htmlFor="startDate" className="update">
                            Start Date *
                          </label>
                          <input
                            type="date"
                            id="startDate"
                            className={`form-control ${this.state.startDateError ? "border-danger" : ""
                              }`}
                            value={this.state.startDate}
                            onChange={this.handleChange}
                            required
                          />
                          {this.state.startDateError && (
                            <small className="text-danger">
                              {this.state.startDateError}
                            </small>
                          )}
                        </div>
                        <div className="form-group mb-3">
                          <label htmlFor="startTime" className="update">
                            Start Time *
                          </label>
                          <input
                            type="time"
                            id="startTime"
                            className={`form-control ${this.state.startTimeError ? "border-danger" : ""
                              }`}
                            value={this.state.startTime}
                            onChange={this.handleChange}
                            required
                          />
                          {this.state.startTimeError && (
                            <small className="text-danger">
                              {this.state.startTimeError}
                            </small>
                          )}
                        </div>
                        <div className="form-group mb-3">
                          <label htmlFor="closureDate" className="update">
                            Closure Date *
                          </label>
                          <input
                            type="date"
                            id="closureDate"
                            className={`form-control ${this.state.closureDateError ? "border-danger" : ""
                              }`}
                            value={this.state.closureDate}
                            onChange={this.handleChange}
                            required
                          />
                          {this.state.closureDateError && (
                            <small className="text-danger">
                              {this.state.closureDateError}
                            </small>
                          )}
                        </div>
                        <div className="form-group mb-3">
                          <label htmlFor="closureTime" className="update">
                            Closure Time *
                          </label>
                          <input
                            type="time"
                            id="closureTime"
                            className={`form-control ${this.state.closureTimeError ? "border-danger" : ""
                              }`}
                            value={this.state.closureTime}
                            onChange={this.handleChange}
                            required
                          />
                          {this.state.closureTimeError && (
                            <small className="text-danger">
                              {this.state.closureTimeError}
                            </small>
                          )}
                        </div>
                        <div className="form-group mb-3">
                          <label htmlFor="resultDate" className="update">
                            Result Date *
                          </label>
                          <input
                            type="date"
                            id="resultDate"
                            className={`form-control ${this.state.resultDateError ? "border-danger" : ""
                              }`}
                            value={this.state.resultDate}
                            onChange={this.handleChange}
                            required
                          />
                          {this.state.resultDateError && (
                            <small className="text-danger">
                              {this.state.resultDateError}
                            </small>
                          )}
                        </div>
                        <div className="form-group mb-3">
                          <label htmlFor="resultTime" className="update">
                            Result Time *
                          </label>
                          <input
                            type="time"
                            id="resultTime"
                            className={`form-control ${this.state.resultTimeError ? "border-danger" : ""
                              }`}
                            value={this.state.resultTime}
                            onChange={this.handleChange}
                            required
                          />
                          {this.state.resultTimeError && (
                            <small className="text-danger">
                              {this.state.resultTimeError}
                            </small>
                          )}
                        </div>
                        <div className="form-group mb-3">
                          <label className="update">Select Languages *</label>
                          <div className="contest-language-checklist">
                            {this.state.availableLanguages.map((language) => (
                              <div key={language.name} className="form-check">
                                <input
                                  type="checkbox"
                                  id={`language-${language.name}`}
                                  className="form-check-input"
                                  checked={this.state.languages.includes(
                                    language.name
                                  )}
                                  onChange={this.handleChange}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`language-${language.name}`}
                                >
                                  {language.name}
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                        <div className="form-group mb-3">
                          <label
                            htmlFor="winnersPerLanguage"
                            className="update"
                          >
                            Winners Per Language *
                          </label>
                          <input
                            type="number"
                            id="winnersPerLanguage"
                            className="form-control"
                            value={this.state.winnersPerLanguage}
                            onChange={this.handleChange}
                            min="1"
                            required
                          />
                        </div>
                        <div className="form-group mb-3">
                          <label
                            htmlFor="totalNumberOfWinners"
                            className="update"
                          >
                            Total Number Of Winners *
                          </label>
                          <input
                            type="number"
                            id="totalNumberOfWinners"
                            className="form-control"
                            value={this.state.totalNumberOfWinners}
                            readOnly
                            style={{
                              backgroundColor: "#e9ecef",
                              cursor: "not-allowed",
                            }}
                          />
                          <small className="form-text text-muted">
                            Total winners is automatically calculated based on
                            selected languages and winners per language
                          </small>
                        </div>
                        <div className="form-group mb-3">
                          <label htmlFor="refId" className="update">
                            Type *
                          </label>
                          <select
                            id="type"
                            className="form-control"
                            value={this.state.type}
                            onChange={this.handleChange}
                            required
                          >
                            <option value="story">Story</option>
                            <option value="poem">poem</option>
                          </select>
                        </div>
                        <div className="form-group mb-3">
                          <label htmlFor="cityName" className="update">
                            City Name
                          </label>
                          <select
                            id="cityName"
                            className="form-control"
                            value={this.state.cityName}
                            onChange={this.handleChange}
                            required
                          >
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                          </select>
                        </div>
                        <div className="form-group mb-3">
                          <label htmlFor="collegeName" className="update">
                            College Name
                          </label>
                          <select
                            id="collegeName"
                            className="form-control"
                            value={this.state.collegeName}
                            onChange={this.handleChange}
                            required
                          >
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                          </select>
                        </div>
                        <div className="form-group mb-3">
                          <label htmlFor="collegeAddress" className="update">
                            College Address
                          </label>
                          <select
                            id="collegeAddress"
                            className="form-control"
                            value={this.state.collegeAddress}
                            onChange={this.handleChange}
                            required
                          >
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                          </select>
                        </div>
                        <div className="form-group mb-3">
                          <label htmlFor="idCard" className="update">
                            ID Card
                          </label>
                          <select
                            id="idCard"
                            className="form-control"
                            value={this.state.idCard}
                            onChange={this.handleChange}
                            required
                          >
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                          </select>
                        </div>
                        <div className="form-group mb-3">
                          <label htmlFor="refId" className="update">
                            Ref ID
                          </label>
                          <select
                            id="refId"
                            className="form-control"
                            value={this.state.refId}
                            onChange={this.handleChange}
                            required
                          >
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                          </select>
                        </div>
                        <div className="form-group mb-3">
                          <label htmlFor="storyPrice" className="update">
                            Story Price
                          </label>
                          <input
                            type="number"
                            id="storyPrice"
                            className="form-control"
                            value={this.state.storyPrice}
                            onChange={this.handleChange}
                            placeholder="0"
                          />
                        </div>
                        <div className="form-group mb-3">
                          <label htmlFor="poemPrice" className="update">
                            Poem Price
                          </label>
                          <input
                            type="number"
                            id="poemPrice"
                            className="form-control"
                            value={this.state.poemPrice}
                            onChange={this.handleChange}
                            placeholder="0"
                          />
                        </div>
                        <div className="form-group mb-3">
                          <label htmlFor="mobileNumber" className="update">
                            Mobile Number Field (Show in Form)
                          </label>
                          <select
                            id="mobileNumber"
                            className="form-control"
                            value={this.state.mobileNumber}
                            onChange={this.handleChange}
                            required
                          >
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                          </select>
                        </div>
                        <div className="form-group mb-3">
                          <label htmlFor="durationRequired" className="update">
                            Duration Field (Show in Form)
                          </label>
                          <select
                            id="durationRequired"
                            className="form-control"
                            value={this.state.durationRequired}
                            onChange={this.handleChange}
                            required
                          >
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                          </select>
                        </div>
                        <div className="form-group mb-3">
                          <label htmlFor="wordLimit" className="update">
                            Word Limit
                          </label>
                          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                            <input
                              type="number"
                              id="wordLimit"
                              className="form-control"
                              value={this.state.wordLimit}
                              onChange={this.handleChange}
                              min="1"
                              placeholder="Leave blank for no limit"
                              style={{ flex: 1 }}
                            />
                            {(this.state.wordLimit !== "" && this.state.wordLimit !== null && this.state.wordLimit !== undefined) && (
                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                onClick={() => this.setState({ wordLimit: "" })}
                                style={{ whiteSpace: "nowrap" }}
                              >
                                Remove Limit
                              </button>
                            )}
                          </div>
                          <small className="form-text text-muted">
                            Maximum words allowed in a submission. Leave blank to allow any length.
                          </small>
                        </div>
                        <div className="form-group mb-3">
                          <label htmlFor="noReview" className="update">
                            Skip Review Step
                          </label>
                          <select
                            id="noReview"
                            className="form-control"
                            value={this.state.noReview}
                            onChange={this.handleChange}
                          >
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                          </select>
                          <small className="form-text text-muted">
                            If Yes, users submit directly without a review page (useful for 5-word contests).
                          </small>
                        </div>
                        <div className="form-group mb-3">
                          <label htmlFor="noVoting" className="update" style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                            No Voting
                            <span
                              title="When enabled, during the voting period (after submission closes, before result is out) only the result countdown will be shown — no entries will be listed for voting."
                              style={{
                                cursor: "help",
                                color: "#6c757d",
                                fontSize: "0.9em",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "16px",
                                height: "16px",
                                borderRadius: "50%",
                                border: "1px solid #6c757d",
                                fontWeight: "bold",
                                lineHeight: 1,
                              }}
                            >
                              i
                            </span>
                          </label>
                          <select
                            id="noVoting"
                            className="form-control"
                            value={this.state.noVoting}
                            onChange={this.handleChange}
                          >
                            <option value="false">No (Show entries for voting)</option>
                            <option value="true">Yes (Only countdown, no voting)</option>
                          </select>
                          <small className="form-text text-muted">
                            If Yes, users will only see the result countdown during the voting period — no entries will be listed.
                          </small>
                        </div>
                        <div className="form-group mb-3">
                          <label htmlFor="targetRequired" className="update">
                            Target Audience Field (Show in Form)
                          </label>
                          <select
                            id="targetRequired"
                            className="form-control"
                            value={this.state.targetRequired}
                            onChange={this.handleChange}
                          >
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                          </select>
                        </div>
                        {this.state.targetRequired === false && (
                          <div className="form-group mb-3">
                            <label htmlFor="defaultTarget" className="update">
                              Select Default Audience
                            </label>
                            <select
                              id="defaultTarget"
                              className="form-control"
                              value={this.state.defaultTarget}
                              onChange={this.handleChange}
                              required
                            >
                              <option value="everyone">Everyone</option>
                              <option value="adult">Adults</option>
                            </select>
                          </div>
                        )}
                        <div className="form-group mb-3">
                          <label htmlFor="categoryControl" className="update">
                            Category Control
                          </label>
                          <select
                            id="categoryControl"
                            className="form-control"
                            value={this.state.categoryControl}
                            onChange={this.handleChange}
                          >
                            <option value="user_selects">Yes (user selects)</option>
                            <option value="hidden">No (Hidden from user)</option>
                            <option value="read_only">No (Read only for user)</option>
                          </select>
                        </div>
                        {this.state.categoryControl !== "user_selects" && (
                          <div className="form-group mb-3">
                            <label htmlFor="defaultCategory" className="update">
                              Select Default Category
                            </label>
                            <select
                              id="defaultCategory"
                              className="form-control"
                              value={this.state.defaultCategory}
                              onChange={this.handleChange}
                              required
                            >
                              <option value="">Select Category</option>
                              {this.state.categoryList.map((cat) => (
                                <option key={cat._id} value={cat._id}>{cat.name}</option>
                              ))}
                            </select>
                          </div>
                        )}
                        <div className="form-group mb-0 contest-submit-wrap">
                          <button
                            type="submit"
                            className={`btn waves-effect waves-light ${this.state.startDateError ||
                                this.state.startTimeError ||
                                this.state.closureDateError ||
                                this.state.closureTimeError ||
                                this.state.resultDateError ||
                                this.state.resultTimeError
                                ? "btn-secondary"
                                : "btn-primary"
                              }`}
                            disabled={
                              this.state.startDateError ||
                              this.state.startTimeError ||
                              this.state.closureDateError ||
                              this.state.closureTimeError ||
                              this.state.resultDateError ||
                              this.state.resultTimeError
                            }
                          >
                            {btnVal}
                          </button>
                          {(this.state.startDateError ||
                            this.state.startTimeError ||
                            this.state.closureDateError ||
                            this.state.closureTimeError ||
                            this.state.resultDateError ||
                            this.state.resultTimeError) && (
                              <small className="text-danger d-block mt-2">
                                Please fix the date/time validation errors before
                                submitting
                              </small>
                            )}
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddUpdate;
